<script>
    import axios from "axios";
    import productImagePreview from "@/components/App/product-image-preview.vue";
    import {CommonMixin} from "@/mixins/commonMethods";
    import {loadImg} from "@/mixins/loadImg";

    export default {
        name: 'SearchOverlay',
        components: {productImagePreview},
        mixins: [CommonMixin, loadImg],
        props: {},
        data: () => ({
            productItems: [],
            searchText: '',
        }),
        computed: {
            filteredItems() {
                if (!this.searchText) {
                    return this.productItems; // Если строка пустая, возвращаем весь массив
                }

                // Фильтруем объекты по всем свойствам
                // Ограничиваем результатом первыми пятью элементами
                return this.productItems.filter(item => {
                    return Object.entries(item).some(([key, value]) => {
                        return String(value).toLowerCase().includes(this.searchText.toLowerCase());
                    });
                }).slice(0, 3);
            },
        },
        methods: {
            closeSearch() {
                if (event) {
                    if (event.key === 'Escape' || event.keyCode === 27) {
                        event.preventDefault();
                        this.$emit('close-search');
                    }
                } else {
                    this.$emit('close-search');
                }
            },
        },
        async mounted() {
            await this.$store.dispatch(`product/fetchProducts`);
            this.productItems = JSON.parse(JSON.stringify(this.$store.state.product.products));

            this.$refs.overlay.classList.add('active');

            window.addEventListener('keydown', this.closeSearch);
            this.loadImages();
        },
        unmounted() {
            window.removeEventListener('keydown', this.closeSearch);
        }
    }
</script>

<template>
    <div class="search-overlay" @keydown.esc.prevent.stop="closeSearch">
        <div class="container" ref="overlay">
            <div class="row justify-content-center">
                <div class="col-lg-6 col-md-6 col-12 content">
                    <div class="close-search" @click="$emit('close-search')">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.75 5.5L0 1.75L1.25 0.5L5 4.25L8.75 0.5L10 1.75L6.25 5.5L10 9.25L8.75 10.5L5 6.75L1.25 10.5L0 9.25L3.75 5.5Z" fill="black"/>
                        </svg>
                        <span>Закрыть</span>
                    </div>

                    <input type="text" v-model="searchText" placeholder="Введите запрос">
                    <div class="results-block" v-if="searchText !== '' && filteredItems">
                        <div class="result-elem" v-for="product of filteredItems">
                            <router-link :to="{ name: 'product-item', params: { code: product['Код'] } }" @click="$emit('close-search')" class="col-3 product-item">
                                <div class="item-img" :style="'background: url(' + setImageThumbURL(product.imageUrl) + ')'">
                                </div>
                                <div class="product-text-block">
                                    <h3 class="product-name">{{ product["Название продукта"] }}</h3>
                                    <div class="sale-block" v-if="product['Цена по скидке'] !== 0 && product['Цена по скидке'] < product['Обычная цена']">
                                        <p class="sale-price">{{ product['Цена по скидке'] }}&#8381;</p>
                                        <p class="default-price">{{ product['Обычная цена'] }}&#8381;</p>
                                    </div>
                                    <div class="default-block" v-else>
                                        <p class="sale-price">{{ product['Обычная цена'] }}&#8381;</p>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <router-link :to="{path: '/products', query: {searchText}}" @click="$emit('close-search')" class="more-products" v-if="searchText !== '' && filteredItems.length > 0">
                        <span>Больше вариантов</span>
                        <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.17305 5.66277L0.728516 1.21824L1.83945 0.107299L5.72852 3.99636L9.61758 0.1073L10.7285 1.21824L6.28398 5.66277C6.13665 5.81006 5.93685 5.8928 5.72852 5.8928C5.52018 5.8928 5.32038 5.81006 5.17305 5.66277Z" fill="#1C1C1C"/>
                        </svg>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;
    .search-overlay {
        padding: 10% 0;
        box-sizing: border-box;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.5);
        backdrop-filter: blur(10px);
        z-index: 6;
    }

    .container {
        transform: translateY(-200px);
        transition: $transition;
        opacity: 0;
    }

    .container.active {
        opacity: 1;
        transform: translateY(0);
    }

    .results-block {
        display: flex;
        flex-direction: column;
        gap: 7px
    }

    .search-overlay .content {
        display: flex;
        flex-direction: column;
        gap: 30px
    }

    .search-block-header {
        padding: 0 1%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        color: $gray
    }

    .item-img {
        height: 50px;
        width: 50px;
        background-size: 100% !important;
        background-position: center !important;
        background-repeat: no-repeat !important;
        border-radius: 10px;
        border: 1px solid $light-gray
    }

    .product-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        background: rgba(255, 255, 255, 0.5);
        box-shadow: $shadow;
        border-radius: 10px;
        border: 1px solid $gray;

        padding: 2% 2.5%;
        box-sizing: border-box;
        gap: 2%;
    }

    .product-name {
        font-size: 16px;
        font-weight: 500;
    }

    .sale-block {
        display: flex;
        gap: 10px
    }

    .default-block, .sale-block {
        margin-top: 10px;
    }

    .product-text-block {
        display: flex;
        gap: 0px;
        flex-direction: column;
    }

    .sale-price {
        font-size: 12px;
        font-weight: 500;
    }

    .default-price {
        font-size: 12px;
        color: $hard-gray;
        text-decoration: line-through;
    }

    .more-products {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 5px;
    }

    .more-products span {
        text-transform: uppercase;
        color: $black;
        transition: $transition;
        cursor: pointer;
        font-weight: 500;
        font-size: 12px;
    }

    .more-products svg {
        padding-bottom: 2px;
    }

    .more-products path {
        transition: $transition;
    }

    .more-products:hover span, .more-products:hover path {
        color: $purple-hover;
        fill: $purple-hover;
    }

    .content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .close-search {
        display: flex;
        align-items: center;
        gap: 5px;
        cursor: pointer;
    }

    .results-block {
        width: 100%;
    }

    .close-search span {
        text-transform: uppercase;
        font-weight: 500;
        font-size: 12px;
    }

    @media screen and (max-width: 750px) {
        .product-item {
            padding: 8px 10px;
            gap: 15px
        }
        .product-name {
            font-size: 14px;
        }

        .sale-block, .default-block {
            margin-top: 5px;
        }

        .sale-price, .default-price {
            font-size: 10px;
        }
    }
</style>